import React, { useCallback, useMemo } from "react";

import { useIntl } from "react-intl";

import { Labeled, SelectField, SelectFieldProps } from "@mapmycustomers/ui";

import TimeZone from "@app/types/TimeZone";
import useAnalytics from "@app/util/contexts/useAnalytics";

import TimeZones from "../../enum/TimeZones";

interface Props extends Pick<SelectFieldProps, "size"> {
  className?: string;
  label?: string;
  onChange?: (zone: TimeZone) => void;
  value?: TimeZone;
}

const TimeZoneSelect: React.FC<Props> = ({
  className,
  label,
  onChange,
  value,
  ...selectFieldProps
}) => {
  const intl = useIntl();
  const analyticIssuer = useAnalytics();
  const options = useMemo(
    () =>
      Object.keys(TimeZones)
        .map((zoneKey) => ({
          label: intl.formatMessage(TimeZones[zoneKey as TimeZone]),
          value: zoneKey,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [intl]
  );

  const handleChange = useCallback(
    (zone: TimeZone) => {
      analyticIssuer?.clicked(["Org Timezone"], { TimeZone: zone });
      onChange?.(zone);
    },
    [analyticIssuer, onChange]
  );

  return (
    <Labeled label={label}>
      <SelectField
        {...selectFieldProps}
        className={className}
        dropdownMatchSelectWidth={false}
        onChange={handleChange}
        options={options}
        showSearch
        value={value}
      />
    </Labeled>
  );
};

export default TimeZoneSelect;
